
//Libraries
import { computed, defineAsyncComponent, defineComponent } from "vue";

//Store
import { useStore } from "../../store/index";

//Types
import { ModalMutationOptions } from "../../shared/types/enum/store-enum";

//Components
import LoadingBar from "../../shared/components/LoadingBar.vue";

export default defineComponent({
  name: "Modal",
  components: {
    LoadingBar,
  },
  setup() {
    //Data
    const store = useStore();

    //Computed
    const isActive = computed(() => {
      return store.state.ModalStore.isModalActive;
    });

    const size = computed(() => {
      return store.state.ModalStore.config.size;
    });

    const title = computed(() => {
      return store.state.ModalStore.config.title;
    });

    const useComponent = computed(() => {
      return defineAsyncComponent(store.state.ModalStore.config.component);
    });

    //Methods
    const closeModal = () => {
      store.commit(ModalMutationOptions.closeModal);
    };

    return {
      //Computed
      isActive,
      size,
      title,
      useComponent,
      //Methods
      closeModal,
    };
  },
});
